import { collapsibleOnClickFactory, collapsibleResizeFactory } from './controllers/collapsible.controllers.js';

collapsibleOnClickFactory(document.querySelectorAll<HTMLElement>('.product-usp summary'));
collapsibleResizeFactory(document.querySelectorAll<HTMLElement>('.product-usp'));
